import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowNodeCommands } from '../constant';
import { Disposable } from '../../common/disposable';
export var NsBackNode;
(function (NsBackNode) {
    /** command */
    NsBackNode.command = XFlowNodeCommands.BACK_NODE;
    /** hook key */
    NsBackNode.hookKey = 'backNode';
})(NsBackNode || (NsBackNode = {}));
let BackNodeCommand = class BackNodeCommand {
    constructor() {
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const { args, hooks: runtimeHook } = this.ctx.getArgs();
            const hooks = this.ctx.getHooks();
            const result = yield hooks.backNode.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const x6Graph = yield this.ctx.getX6Graph();
                const { nodeId } = handlerArgs;
                const x6Node = x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.getCellById(nodeId);
                if (!x6Node) {
                    console.error(nodeId, 'this nodeId is not exist');
                }
                else {
                    x6Node.toBack();
                    /** backNode undo */
                    this.ctx.addUndo(Disposable.create(() => __awaiter(this, void 0, void 0, function* () {
                        handlerArgs.commandService.executeCommand(XFlowNodeCommands.FRONT_NODE.id, {
                            nodeId,
                        });
                    })));
                }
                return {};
            }), runtimeHook);
            this.ctx.setResult(result);
            return this;
        });
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], BackNodeCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], BackNodeCommand.prototype, "init", null);
BackNodeCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsBackNode.command.id },
    })
    /** 节点前置命令(始终在画布最前方) */
], BackNodeCommand);
export { BackNodeCommand };
//# sourceMappingURL=node-back.js.map